import {Component, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import * as _ from 'lodash';
import {StateMap, UnitOfWork, UserManager} from '../../services/common';
import {PageState} from '../../controls/common';

import {MATERIAL_ROUTES} from './material.routes';
import {ExpertPanelSummary, Material, MaterialExpertPanelSummary, MaterialMonograph } from '../../entities/EntityModels';

import { MaterialFileManagerComponent } from './material-file-manager.component';

import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {MaterialWorkflowService} from '../../services/material-workflow-service';

export class PublicationData {
    isEditingFiles: boolean;
}

@Component({
    selector: 'publications',
    templateUrl: './publications.html',
    providers: [MaterialWorkflowService],
})
export class PublicationsComponent implements OnInit {
    @ViewChild(MaterialFileManagerComponent) _materialFileManagerComponent: MaterialFileManagerComponent;

    _material: Material;
    _pageState = new PageState('Publications');
    _fmr: MaterialExpertPanelSummary;
    _monographs: MaterialMonograph[];
    _allSummaries: ExpertPanelSummary[];
    _summaries: ExpertPanelSummary[];   // with Narrative Links
    _hasMonographFiles: boolean;

    // file download links
    _expertPanelSummarySubFolder = 'Expert Panel Summaries';
    _documentManagementUrl: string;
    _isLoading = false;
    _validationMessage = '';

    _data: PublicationData;

    constructor(public _uow: UnitOfWork, public _userManager: UserManager, public _stateMap: StateMap,
        public _location: Location, private _httpClient: HttpClient) {
        this._data = new PublicationData();
        this._data.isEditingFiles = false;
    }

    ngOnInit() {
        this._stateMap.currentRouteName = MATERIAL_ROUTES.Publications.name;
        this._material = this._stateMap.currentMaterial;
        this._material.principalSynonym().synonymWordOrWebVersion();

        this._pageState.isLoading = true;
        this._uow.materialExpertPanelSummaryRepository.whereWithParams({materialId: this._material.materialId}).then(r => {
            this._fmr = _.find(r, m => m.review != null);
            this._allSummaries = r.map(item => item.expertPanelSummary);
            this._summaries = this._allSummaries.filter(s => s.narrativeLink != null && s.narrativeLink.trim() != '');
            this._hasMonographFiles = (this._material.materialMonographs != null && this._material.materialMonographs.length > 0);
            this._pageState.isLoaded = (this._allSummaries.length > 0) || (this._fmr != null) || this._hasMonographFiles;
        });

        this._documentManagementUrl = this._stateMap.documentManagementBaseUrl + '/RIFMDownloadableFile';
        this._stateMap.documentManagementUrl = this._documentManagementUrl;
    }

    get materialMonographFiles() {
        return _.sortBy(this._material.materialMonographs, l => l.fileLabel);
    }

    linkToSummary(summary: ExpertPanelSummary) {
        this.downloadPublicationFile(summary.narrativeLink, 'Expert Panel Summaries');
    }

    linkToFmr() {
        this.downloadPublicationFile(this._fmr.review, 'Expert Panel Summaries');
    }

    linkToMonographFile(m: MaterialMonograph) {
        this.downloadPublicationFile(m.fileName, 'Monographs');
    }

    isStaff() {
        return this._stateMap.currentUser.isStaff;
    }

    // File Editing for Staff
    onEditFiles() {
        this._data.isEditingFiles = true;
    }

    refreshMonographStatus() {
        this._pageState.isLoading = true;

        this._material = this._stateMap.currentMaterial;
        this._hasMonographFiles = (this._material.materialMonographs != null && this._material.materialMonographs.length > 0);

        this._pageState.isLoaded = (this._allSummaries.length > 0) || (this._fmr != null) || this._hasMonographFiles;
    }

    getDownloadFileURL(fileName: string, subFolder: string): Observable<any> {
        let url: string;
        url = this._documentManagementUrl + '/GetFileBySubFolderAndName?fileName=' + fileName + '&subFolder=' + subFolder ;

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public downloadPublicationFile(fileName: string, subFolder: string) {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL(fileName, subFolder)
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    const file = new Blob([data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);

                    // window.open(fileURL);
                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = fileName;
                    document.body.appendChild(a);
                    a.click();
                    
                    a.remove();

                    window.URL.revokeObjectURL(fileURL);                    

                    this._validationMessage = '';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
